import React from "react";
import { Link } from "react-router-dom";
import { Building2, CheckCircle } from "lucide-react";

const LoginLandingPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50 flex">
      <div
        className="hidden lg:flex lg:w-1/2 relative"
        style={{ backgroundColor: "#0076b5" }}
      >
        <div className="absolute inset-0 bg-gradient-to-br from-blue-900 to-blue-700 opacity-90" />
        <div className="relative z-10 flex flex-col justify-center px-12 text-white">
          <div className="mb-8">
            <div className="w-16 h-16 bg-white bg-opacity-20 rounded-lg flex items-center justify-center mb-4">
              <Building2 className="h-8 w-8 text-white" />
            </div>
            <h1 className="text-4xl font-bold mb-2">VPD Employer Portal</h1>
            <p className="text-blue-100">
              Sign in through your employer account or register a new business.
            </p>
          </div>
          <div className="space-y-6">
            <div className="flex items-center space-x-3">
              <CheckCircle className="h-5 w-5 text-green-300" />
              <span className="text-blue-100">Secure corporate admin access</span>
            </div>
            <div className="flex items-center space-x-3">
              <CheckCircle className="h-5 w-5 text-green-300" />
              <span className="text-blue-100">Employee and payroll oversight</span>
            </div>
          </div>
        </div>
      </div>

      <div className="flex-1 flex items-center justify-center px-4 sm:px-6 lg:px-8">
        <div className="max-w-md w-full space-y-8">
          <div>
            <h2 className="text-3xl font-bold text-gray-900">Welcome</h2>
            <p className="mt-2 text-sm text-gray-600">
              Use the portal after approval, or register your business to get
              started.
            </p>
          </div>
          <div className="space-y-4">
            <Link
              to="/onboard"
              className="w-full flex justify-center py-3 px-4 rounded-lg text-sm font-medium text-white"
              style={{ backgroundColor: "#0076b5" }}
            >
              Register your business
            </Link>
            <p className="text-sm text-gray-500 text-center flex items-center justify-center gap-2 flex-wrap">
              <span>Existing clients:</span>
              <Link
                to="/login"
                className="inline-flex items-center px-4 py-1.5 rounded-full bg-blue-50 text-[#0076b5] text-sm font-medium hover:bg-blue-100 transition-colors"
              >
                Click here
              </Link>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginLandingPage;
